module.exports = __webpack_public_path__ + "img/2_2-residenziale-villette-0.0c5e8ae1.png";